import { SliceComponentProps } from "gatsby";
import React from "react";
import SliceProviders from "./SliceProviders";
import { CustomPromoSliceContext } from "./types";
import CustomPromo from "components/CustomPromo/CustomPromo";

const CustomPromoComponentsSlice: React.FC<
  SliceComponentProps<never, CustomPromoSliceContext>
> = ({ sliceContext }) => (
  <SliceProviders languageCode={sliceContext.languageCode}>
    <CustomPromo />
  </SliceProviders>
);

export default CustomPromoComponentsSlice;
